/* eslint-disable  */
//@ts-nocheck

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { TextField } from '@mui/material';

class TagEditor extends React.Component<any> {
  constructor(props) {
    super(props);
    this.state = { tag: '' };
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.remove = this.remove.bind(this);
  }
  handleKeyPress(e) {
    if (e.key === 'Enter' && this.state.tag && this.state.tag.length > 0) {
      //don't fire off onChange()
      e.preventDefault();
      var tags = this.props.tags;
      if (this.props.tags.length === 0) {
        tags.push(this.state.tag);
        this.props.onChange(tags);
      } else {
        var alreadyExists = false;
        // check if tag already exists
        for (var i = 0; i < this.props.tags.length; i++) {
          if (
            this.props.tags[i].toLowerCase() === this.state.tag.toLowerCase()
          ) {
            alreadyExists = true;
          }
        }
        if (!alreadyExists) {
          // tag is new, so push it into tags array
          tags.push(this.state.tag);
          this.props.onChange(tags);
        }
      }
      // blank input
      this.setState({ tag: '' });
    }
  }
  handleChange(event) {
    // strip spaces, hashtags, anything not allowed
    let tag = '';
    if (this.props.allowSpaces) {
      tag = event.target.value.replace(/[^0-9a-zA-Z\s]+/g, '');
      //tag = event.target.value.replace(/[\W_]+/g, '');
    } else {
      tag = event.target.value.replace(/[\W_]+/g, '');
    }
    this.setState({ tag });
  }
  remove(tag) {
    var tags = this.props.tags;
    for (var index = 0; index < this.props.tags.length; index++) {
      if (this.props.tags[index].toLowerCase() === tag.toLowerCase()) {
        tags.splice(index, 1);
        this.props.onChange(tags);
      }
    }
  }
  render() {
    let placeholder = this.props.placeholder
      ? this.props.placeholder
      : 'Enter tag here...';

    let items = [];
    if (this.props.tags && this.props.tags.length > 0) {
      for (var i = 0; i < this.props.tags.length; i++) {
        var tag = this.props.tags[i];
        items.push(
          <TagEditorItem id={tag} key={tag} value={tag} remove={this.remove} />,
        );
      }
    }
    let input = '';
    if (!this.props.maxItems || this.props.maxItems > this.props.tags.length) {
      input = (
        <TextField
          style={{ display: 'inline-block', width: '200px' }}
          ref="input"
          disabled={this.props.disabled}
          value={this.state.tag}
          onKeyPress={this.handleKeyPress}
          onChange={this.handleChange}
          placeholder={placeholder}
          inputProps={{
            maxLength: this.props.maxLength ? this.props.maxLength : undefined,
          }}
        />
      );
    }

    return (
      <div className="tagEditor">
        <div className="flex flex-wrap gap-2">
          {items}
          {input}
        </div>
      </div>
    );
  }
}

class TagEditorItem extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div
        className="text-center"
        style={{
          height: '40px',
        }}
        key={this.props.value}
      >
        <div
          className="flex flex-nowrap whitespace-nowrap"
          style={{
            padding: '9px 12px',
            background: '#f2f4f6',
            borderRadius: '5px',
          }}
        >
          {this.props.value}
          <a
            className="actionLink ml-2"
            onClick={() => this.props.remove(this.props.value)}
          >
            <FontAwesomeIcon
              icon={faTimes}
              className="text-black hover:text-[#626BE7]"
            />
          </a>
        </div>
      </div>
    );
  }
}

export default TagEditor;
